import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemServicoDetalheJanelaComponent } from './item-servico-detalhe-janela.component';
import { ItemServicoDetalheJanelaRoutingModule } from './item-servico-detalhe-janela-routing.module';

import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';


@NgModule({
  declarations: [
    ItemServicoDetalheJanelaComponent
  ],
  imports: [
    CommonModule,
    ItemServicoDetalheJanelaRoutingModule,
    FormsModule,
    InputNumberModule,
    DividerModule,
    MessagesModule,
    ProgressSpinnerModule
  ]
})
export class ItemServicoDetalheJanelaModule { }
